import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { KeyFilterModule } from 'primeng/keyfilter';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  imports: [ReactiveFormsModule, AutoCompleteModule, KeyFilterModule],
  template: `
    <p-autocomplete
      pKeyFilter="num"
      [formControl]="chipsObject"
      multiple
      [id]="key?.toString()"
      [typeahead]="false"
      [addOnBlur]="true"
      [addOnTab]="true"
      separator=","
      (onAdd)="onChipChanged()"
      (onUnselect)="onChipChanged()"
      (keydown.enter)="onChipChanged()"
      [placeholder]="props.placeholder || ''"
      fluid
    >
      <ng-template #selecteditem let-value>
        {{ props['prefix'] || '' }}{{ value }}{{ props['suffix'] || '' }}
      </ng-template>
    </p-autocomplete>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyChipsNumberComponent extends FieldType<FieldTypeConfig> implements OnInit {
  readonly chipsObject = new FormControl();
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.chipsObject.setValue(this.formControl?.value || []);
    this.formControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        if (JSON.stringify(this.chipsObject.value) !== JSON.stringify(value)) {
          this.chipsObject.setValue(value || [], { emitEvent: false });
        }
      });
  }

  onChipChanged() {
    const chips = this.chipsObject.value;
    if (!Array.isArray(chips)) {
      return;
    }

    // sort, ensure numbers, and remove duplicates
    const processed = chips
      .map((item: any) => Number(item))
      .filter((item: number, index: number, self: number[]) => !isNaN(item) && self.indexOf(item) === index)
      .sort((a: number, b: number) => a - b);

    // Update if different to maintain consistency
    if (JSON.stringify(processed) !== JSON.stringify(chips)) {
      this.chipsObject.setValue(processed, { emitEvent: false });
    }
    this.formControl.setValue(processed);
  }
}
